
window.onclick = function () {
  validSession()
};

window.onload = function () {
  validSession()
};

const validSession = () => {
  var d = new Date();
  d.setMinutes(d.getMinutes() + 30);
  let now = new Date().getTime();
  const expiresAt = d.getTime();
  let setupTime = sessionStorage.getItem('setupTime');
  if (setupTime == null) {
    sessionStorage.setItem('setupTime', expiresAt)
  } else {
    if (now > setupTime) {
      sessionStorage.clear()
      sessionStorage.setItem('setupTime', expiresAt);
      location.reload();
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/expireSession.js